/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListQuery } from './listQuery.schema';

export const GetCoordinators = zod.object({
  "payload": zod.lazy(() => ListQuery).optional()
});

export type GetCoordinators = zod.input<typeof GetCoordinators>;
export type GetCoordinatorsOutput = zod.output<typeof GetCoordinators>;
